// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M14.5 8C14.5 10.82 12.69 13.31 10.01 14.18C7.33 15.05 4.4 14.1 2.74 11.82C1.09 9.54 1.09 6.46 2.74 4.18C4.4 1.9 7.33 0.95 10.01 1.82',
];
